import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'logout',
        (state.get('logout') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, action) {
    return state.set(
        'logout',
        (state.get('logout') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', fromJS(action.errors))
    );
}

export function finish(state) {
    return state
        .set('authenticated', false)
        .set('data', Map())
        .set('signup', Map())
        .set(
            'logout',
            (state.get('logout') || Map())
                .set('state', 'FINISHED')
                .set('errors', void 0)
        );
}
